/**
 * personName - ONE rule for a person's display name: First Middle Last Suffix.
 *
 * Bill 2026-09-11 (ruling): "Always include middle initial/name and suffixes
 * when they exist in every UI surface including all labels - it makes it
 * impossible to discern between people when only the first and last name is
 * used." Every label that used to do [firstName, lastName].join(' ') goes
 * through here. Matching logic (SignNow signer reconciliation) is deliberately
 * NOT changed - that compares against what the signing engine holds.
 */
export interface PersonNameParts {
  firstName?: string | null;
  middleName?: string | null;
  middleInitial?: string | null;
  lastName?: string | null;
  suffix?: string | null;
}

export function formatPersonName(p: PersonNameParts | null | undefined): string {
  if (!p) return '';
  const middle = (p.middleName ?? p.middleInitial ?? '').trim();
  return [p.firstName, middle, p.lastName, p.suffix]
    .map((x) => (x ?? '').trim())
    .filter(Boolean)
    .join(' ');
}
